import { useState, useEffect } from 'react'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import ItemTabs from 'components/ItemTabs'
import CustomerPersonalInfo from './PersonalInfo'
import CustomerSchedules from './Schedules'
import CustomerBills from './Bills'
// import CustomerProducts from './Products'
import CustomerCredits from './Credits'
import CustomerBundles from './Bundles'
import CustomerLoyaltyCards from './LoyaltyCards'
import CustomerRecord from './Record'
import CustomerAttachments from './Attachments'

export default function CustomerModal ({
  visible,
  data: customer,
  onBalanceUpdate: handleBalanceUpdate = () => {},
  onClose: handleClose
}) {
  const [customerData, setCustomerData] = useState (customer)
  const [activeTab, setActiveTab] = useState ('personal')

  const updateBalance = newBalance => {
    handleBalanceUpdate (newBalance)
    setCustomerData ({
      ...customerData,
      balance: newBalance
    })
  }

  const TAB_LIST = [
    {label: 'Dados pessoais', value: 'personal', component: <CustomerPersonalInfo customer={customerData}/>},
    {label: 'Agendamentos', value: 'schedules', component: <CustomerSchedules customer={customerData}/>},
    {label: 'Comandas', value: 'bills', component: <CustomerBills customer={customerData}/>},
    // {label: 'Produtos', value: 'products', component: <CustomerProducts customer={customerData}/>},
    {label: 'Créditos', value: 'credits', component: <CustomerCredits customer={customerData} onBalanceUpdate={updateBalance}/>},
    {label: 'Pacotes', value: 'packages', component: <CustomerBundles customer={customerData} onBalanceUpdate={updateBalance}/>},
    {label: 'Fidelidade', value: 'loyalty_cards', component: <CustomerLoyaltyCards customer={customerData}/>},
    {label: 'Prontuário', value: 'record', component: <CustomerRecord customer={customerData}/>},
    {label: 'Anexos', value: 'attachments', component: <CustomerAttachments customer={customerData}/>}
  ]

  useEffect (() => {
    setCustomerData (customer)
    setActiveTab ('personal')
  }, [customer])

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      {/* Sem fechar no clique fora: a aba Prontuário tem o campo do novo registro */}
      <DialogContent size='2xl' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>{customer.name}</DialogTitle>
        </DialogHeader>
        {/* As abas ficam paradas entre o título e o corpo, que rola */}
        <div style={{paddingInline: 24}}>
          <ItemTabs
            tabs={TAB_LIST}
            selectedTab={activeTab}
            onTabChange={setActiveTab}
            containerStyle={{paddingTop: 0}}
            tabWidth={130}
          />
        </div>
        {/* O id é o `scrollableTarget` da rolagem infinita da aba Agendamentos (ScheduleList) */}
        <DialogBody id='customer-modal'>
          {TAB_LIST.find (tab => tab.value === activeTab)?.component}
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
